import React, { useState, useEffect, useMemo } from 'react';
import ScoreDefaultWrapper from './default';
import SportsLoader from '../../../../components/sportsLoader';
import HotMatchLayer from '../HotMatchLayer';
import SportsAdsense from './default/AdSense';
import useStore from "../../../../hooks/useStore";
import Banner from "../../../../components/banner";

const ScoreWrapper = ({
  loading,
  selectedGames,
  setSelectedGame,
  list,
  sportsType,
  fromHome
}) => {
  const [initView, setInitView] = useState(false);
  const [viewHotLayer, setViewHotLayer] = useState(false);
  const { bannerStore } = useStore();

  const handleToggleSetViewHotLayer = () => {
    setViewHotLayer(!viewHotLayer);
  };

  useEffect(() => {
    if (!loading) {
      setInitView(true);
      bannerStore.clearActiveMajorView();
    } else {
      setInitView(false);
    }
  }, [loading]);

  if (!initView) {
    return <SportsLoader />;
  }

  if (initView && list.size > 0) {
    return (
      <>
        <ScoreDefaultWrapper
          handleToggleSetViewHotLayer={handleToggleSetViewHotLayer}
          sportsType={sportsType}
          list={list}
          data-adtest="on"
          selectedGames={selectedGames}
          setSelectedGame={setSelectedGame}
          fromHome={fromHome}
        />
        <HotMatchLayer
          viewHotLayer={viewHotLayer}
          selectedGames={selectedGames}
          setSelectedGame={setSelectedGame}
          handleToggleSetViewHotLayer={handleToggleSetViewHotLayer}
        />
      </>
    );
  }

  if (initView && list.size === 0) {
    return (
      <>
        <Banner
          marginTop="10px"
          marginBottom="10px"
        />
        <div className="empty_score">
          <dl>
            <dt>경기 일정이 없습니다.</dt>
            <dd>
              경기 결과나 예정 경기는 달력을 클릭하시면 편하게 찾아보실 수
              있습니다.
            </dd>
          </dl>
        </div>
      </>
    );
  }

  return <></>
};

export default ScoreWrapper;
